import React from 'react';
import { Outlet } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import NavigationBar from './NavigationBar';
import Contact from './Contact';
import data from './../data.json';

const Layout = ({ mode, toggleTheme }) => {
  const location = useLocation();
  return (
    <>
      <NavigationBar mode={mode} toggleTheme={toggleTheme} />
      <div style={{ height: '48px' }} />
      <Outlet />
      {location.pathname !== '/contact' ? (
        <Contact contact={data.contact} />
      ) : (
        <></>
      )}
    </>
  );
};

export default Layout;
